import { render, staticRenderFns } from "./BlackoutContentTemplates.vue?vue&type=template&id=22c17139"
import script from "./BlackoutContentTemplates.vue?vue&type=script&lang=js"
export * from "./BlackoutContentTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports